// src/components/ui/illustrations/StatusFace.tsx
// The good/partial/poor face marker — a choice-matrix's "your status" column
// (Phase 2). See docs/HMS_V4_PRECONSULT_REDESIGN_PLAN.md Phase 0. Deliberately
// a distinct MOUTH SHAPE per tone, not just a colour swap, so the verdict
// still reads at 34px in greyscale — see Details.dc.html's plate-fill board.
import { ILLUSTRATION_SIZE_PX, TONE_FILL_VAR, type IllustrationSize, type IllustrationTone } from './PlateFill';

const MOUTH: Record<IllustrationTone, string> = {
  success: 'M8 14.5c1 1.6 3 1.6 4 1.6s3 0 4-1.6M9 9.5h.01M15 9.5h.01',
  warn: 'M8.5 15.5h7M9 9.5h.01M15 9.5h.01',
  danger: 'M8 16c1-1.6 3-1.6 4-1.6s3 0 4 1.6M9 9.5h.01M15 9.5h.01',
};

export interface StatusFaceProps {
  tone: IllustrationTone;
  size?: IllustrationSize;
  title?: string;
}

export function StatusFace({ tone, size = 'md', title }: StatusFaceProps) {
  const px = ILLUSTRATION_SIZE_PX[size];
  return (
    <svg width={px} height={px} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {title && <title>{title}</title>}
      <circle cx="12" cy="12" r="10" fill={TONE_FILL_VAR[tone]} />
      <path d={MOUTH[tone]} stroke="var(--color-primary-foreground)" strokeWidth={1.6} fill="none" strokeLinecap="round" />
    </svg>
  );
}
